import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  selector: 'flo-faq-question',
  templateUrl: './faq-question.component.html',
  styleUrls: ['./faq-question.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FaqQuestionComponent {
  @Input()
  question: string

  public showAnswerContainer = false
}
